import FoundationIcon from "@mui/icons-material/Foundation";
import { GraduationServicePath, TRAINING_BASES } from "utils/constants";
import permissions from "app/permissions";
import ListTrainingBases from "./List";
import CreateTrainingBases from "./Create";
import EditTrainingBases from "./Edit";
import ShowTrainingBases from "./Show";

export const resources = {
  isMenu: true,
  icon: <FoundationIcon />,
  name: GraduationServicePath + TRAINING_BASES,
  title: "Учебни бази",
  list: <ListTrainingBases />,
  create: <CreateTrainingBases />,
  edit: <EditTrainingBases />,
  show: <ShowTrainingBases />,
  permission: permissions.canPreviewTrainingBases,
};
